import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M9.795 13.92L2.946 19v-5.08H0V0h21v13.92H9.795z" fill="#065DC6" /><path d="M4.2 4.222h13.3v1.791H4.2zm0 3.582h7.389v1.791H4.2z" fill="#FFF" /></g></svg>);